/* eslint-disable no-proto */
import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { DateFilter } from '@bingads-webui/date-filter';
import { RANGES } from '@bingads-webui/date-ranges';
import { withoutTime } from '@bingads-webui/primitive-utilities';
import { dateUtils } from '../../hotel-center-utils';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const { DownloadViewV1 } = globalContext.require('campaignui/feature/griddownload/view/adapter');
const state = globalContext.require('component/state/index');
const { local2account } = dateUtils;
const includeRanges = [RANGES.CUSTOM, RANGES.TODAY, RANGES.YESTERDAY, RANGES.THIS_WEEK_SUNDAY,
  RANGES.THIS_WEEK_MONDAY, RANGES.LAST_SEVEN_DAYS, RANGES.LAST_WEEK_SUNDAY,
  RANGES.LAST_WEEK_MONDAY, RANGES.LAST_FOURTEEN_DAYS, RANGES.THIS_MONTH, RANGES.LAST_MONTH,
  RANGES.LAST_THIRTY_DAYS, RANGES.ALL_TIME];

export class PerformanceReportBase extends DeterministicView {
  initialize({
    getTemplate,
    downloadButtonLocator,
    reportColumns,
    reportHeaders,
    gridId,
    processReportRule,
    p$daterange,
    perfMarker,
  }) {
    _.extend(this, {
      i18n,
      getTemplate,
      downloadButtonLocator,
      reportColumns,
      reportHeaders,
      gridId,
      processReportRule,
      p$daterange,
      perfMarker,
    });
    if (this.perfMarker) {
      this.perfMarker.willInit();
      this.on('rendered', () => {
        this.perfMarker.done();
      });
    }
    this.initDateFilter();
  }

  get events() {
    return {
      [`click ${this.downloadButtonLocator}`]: this.onReportDownload,
    };
  }

  get template() {
    return this.getTemplate();
  }

  initDateFilter() {
    const today = withoutTime(local2account(new Date()));
    const dateFilterConfig = {
      i18n: _.defaults({
        timeZone: null,
        __proto__: i18n.__proto__,
      }, i18n),
      isComparisonEnabled: false,
      enabledRangesPredicate: range => _.contains(includeRanges, range.key),
      dateFormat: 'yMd',
      get maxDate() {
        return today;
      },
    };
    let selection = { primaryRange: { key: RANGES.LAST_THIRTY_DAYS } };

    // get $daterange from state if exist
    state.getPromise('$daterange').then((dateRange) => {
      if (dateRange && dateRange.key && _.contains(includeRanges, dateRange.key)) {
        selection = { primaryRange: _.omit(dateRange, 'compared') };
      }
    }).finally(() => {
      const dateFilter = new DateFilter(dateFilterConfig).setState({ today, selection });

      this.setChild('date-filter', dateFilter);
    });
  }

  onReportDownload() {
    const { primaryRange } = this.getChild('date-filter').getSelection();
    const downloadView = new DownloadViewV1({
      localizedHeaders: this.reportHeaders,
      odataColumnNames: this.reportColumns,
      filterUrlParam: '',
      segmentationTypes: [],
      entity: 'DimensionRow',
      gridId: this.gridId,
      processReportRule: this.processReportRule,
      isForVNext: true,
      p$daterange: this.p$daterange,
    });

    state.set('$daterange', primaryRange);
    downloadView.download();
    downloadView.remove();
  }
}
